import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	container: {
		borderRadius    : "1rem",
		backgroundColor : theme.other.darkMode ?
			theme.other.paletteNew.darkModeInclinedBlack2 :
			theme.other.paletteNew.darkModeDarkGrey,
		padding : "2rem",
		height  : "37vh"
	},
	image: {
		width: "35vw"
	},
	instructions: {
		marginBottom: "1rem"
	},
	stepText: {
		marginBottom: "0.5rem"
	}
} ) );

